import app from '../app';

// value initialized later from app/blocks/add-form/add-form.controller.js
app.value('regions', []);
